var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckCircleFilled = function SvgCheckCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "check_circle-filled_svg__a",
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm5.24 7.311a.975.975 0 0 0-1.38-1.379l-5.566 5.567-2.155-2.154a.975.975 0 1 0-1.378 1.379l2.843 2.844a.975.975 0 0 0 1.38 0l6.255-6.257Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#check_circle-filled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#34D399",
    d: "M0 0h24v24H0z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircleFilled);
export default ForwardRef;